import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

const AspectRatioSelector = ({ aspectRatio, setAspectRatio, aspectRatioOptions }) => {
  const [aspectDropdownOpen, setAspectDropdownOpen] = useState(false);


  const selected = aspectRatioOptions.find(opt => opt.value === aspectRatio.value);

  return (
    <div className="relative">
      <div
        className={`flex items-center px-3 py-3 border rounded-xl shadow-sm transition-all duration-300 cursor-pointer group bg-white min-w-[180px] ${aspectDropdownOpen ? 'border-purple-500 ring-2 ring-purple-200' : 'border-gray-200 hover:shadow-md'}`}
        onClick={() => setAspectDropdownOpen((open) => !open)}
        tabIndex={0}
        id="aspect-ratio-container"
      >
        <span className="text-gray-800 text-sm">{selected.desc}</span>
        <span className="text-gray-400 text-sm ml-auto text-right flex-1">{selected.label}</span>
        <FontAwesomeIcon
          icon={aspectDropdownOpen ? faChevronDown : faChevronRight}
          className="text-gray-400 ml-2 flex-shrink-0 transition-transform duration-300 pr-1"
        />
      </div>
      {aspectDropdownOpen && (
        <div
          className="absolute z-50 bg-white border border-gray-200 rounded-2xl shadow-2xl py-2 px-1 max-h-96 overflow-y-auto w-full mt-2"
          style={{
            top: '100%',
            left: '0'
          }}
        >
          {aspectRatioOptions.map((opt, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-3 px-4 py-2 cursor-pointer rounded-xl transition-colors duration-200 ${aspectRatio.value === opt.value ? 'bg-purple-50 border border-purple-200' : 'hover:bg-gray-50'}`}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setAspectRatio(opt);
                setAspectDropdownOpen(false);
              }}
            >
              <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center bg-white relative overflow-hidden`}>
                <div
                  className={`border-2 rounded-sm ${aspectRatio.value === opt.value ? 'border-purple-500' : 'border-gray-400'}`}
                  style={{
                    width: opt.value >= 1 ? '100%' : `${opt.value * 100}%`,
                    height: opt.value >= 1 ? `${(1 / opt.value) * 100}%` : '100%',
                  }}
                ></div>
              </div>
              <span className={`text-base ${aspectRatio.value === opt.value ? 'text-purple-700' : 'text-gray-800'}`}>{opt.label}</span>
              <span className="text-gray-400 text-base ml-2">{opt.desc}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AspectRatioSelector; 